/**
 * This function calculates the percentageStart and percentageEnd for pages in a Document
 * and returns the page which lies in the percentageOfDocument provided
 * @method getPageForPercentageOfDocumentWithoutFrame
 */
const getPageForPercentageOfDocumentWithoutFrame = (
  document,
  percentageOfDocument,
) => {
  if (!document.charsInDocumentPages || !percentageOfDocument) {
    return document.pages?.[0] ?? null;
  }

  let charsCounted = 0;
  for (let page of document.pages) {
    const startPercent = charsCounted / document.charsInDocumentPages;
    const endPercent =
      (page.characterCount + charsCounted) / document.charsInDocumentPages;

    charsCounted += page.characterCount;

    if (
      percentageOfDocument > startPercent &&
      percentageOfDocument < endPercent
    ) {
      return page;
    }
  }
};

export default getPageForPercentageOfDocumentWithoutFrame;
